import { addDays, set } from "date-fns";
import { fromZonedTime, toZonedTime } from "date-fns-tz";

import { IDefaultBookingDuration } from "../logic/api";

const millisecondsPerDay = 24 * 60 * 60 * 1000;

export function calculateDefaultBookingEndDate(
  bookingStartDate: string | Date | null | undefined,
  duration: IDefaultBookingDuration | null | undefined,
  usesMidnight: boolean,
  timeZone: string,
): string | undefined {
  if (
    bookingStartDate == null ||
    duration == null ||
    !Number.isInteger(duration.quantity) ||
    duration.quantity <= 0
  ) {
    return undefined;
  }

  const startDate = new Date(bookingStartDate);
  if (isNaN(startDate.getTime())) {
    return undefined;
  }

  if (!usesMidnight) {
    return new Date(startDate.getTime() + duration.quantity * millisecondsPerDay).toISOString();
  }

  try {
    const zonedStart = toZonedTime(startDate, timeZone);
    const zonedEnd = set(addDays(zonedStart, duration.quantity), {
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    });

    return fromZonedTime(zonedEnd, timeZone).toISOString();
  } catch {
    return undefined;
  }
}
